export var AnnotationReference;
(function (AnnotationReference) {
    AnnotationReference["PdbEntity"] = "PDB_ENTITY";
    AnnotationReference["PdbInstance"] = "PDB_INSTANCE";
    AnnotationReference["PdbInterface"] = "PDB_INTERFACE";
    AnnotationReference["Uniprot"] = "UNIPROT";
})(AnnotationReference || (AnnotationReference = {}));
export var FeaturesAdditionalPropertiesPropertyName;
(function (FeaturesAdditionalPropertiesPropertyName) {
    FeaturesAdditionalPropertiesPropertyName["CardModelDescription"] = "CARD_MODEL_DESCRIPTION";
    FeaturesAdditionalPropertiesPropertyName["CardModelOrganism"] = "CARD_MODEL_ORGANISM";
    FeaturesAdditionalPropertiesPropertyName["CathDomainId"] = "CATH_DOMAIN_ID";
    FeaturesAdditionalPropertiesPropertyName["CathName"] = "CATH_NAME";
    FeaturesAdditionalPropertiesPropertyName["ClinicalSignificance"] = "CLINICAL_SIGNIFICANCE";
    FeaturesAdditionalPropertiesPropertyName["ConsequenceType"] = "CONSEQUENCE_TYPE";
    FeaturesAdditionalPropertiesPropertyName["DiseaseType"] = "DISEASE_TYPE";
    FeaturesAdditionalPropertiesPropertyName["EcodDomainId"] = "ECOD_DOMAIN_ID";
    FeaturesAdditionalPropertiesPropertyName["EcodFamilyName"] = "ECOD_FAMILY_NAME";
    FeaturesAdditionalPropertiesPropertyName["Evidence"] = "EVIDENCE";
    FeaturesAdditionalPropertiesPropertyName["Link"] = "LINK";
    FeaturesAdditionalPropertiesPropertyName["ModelcifModelId"] = "MODELCIF_MODEL_ID";
    FeaturesAdditionalPropertiesPropertyName["MutatedType"] = "MUTATED_TYPE";
    FeaturesAdditionalPropertiesPropertyName["OmegaAngle"] = "OMEGA_ANGLE";
    FeaturesAdditionalPropertiesPropertyName["ParentCompId"] = "PARENT_COMP_ID";
    FeaturesAdditionalPropertiesPropertyName["PartnerAsymId"] = "PARTNER_ASYM_ID";
    FeaturesAdditionalPropertiesPropertyName["PartnerBondDistance"] = "PARTNER_BOND_DISTANCE";
    FeaturesAdditionalPropertiesPropertyName["PartnerCompId"] = "PARTNER_COMP_ID";
    FeaturesAdditionalPropertiesPropertyName["PdbModelNum"] = "PDB_MODEL_NUM";
    FeaturesAdditionalPropertiesPropertyName["PredictedImpact"] = "PREDICTED_IMPACT";
    FeaturesAdditionalPropertiesPropertyName["Scop_2DomainId"] = "SCOP_2_DOMAIN_ID";
    FeaturesAdditionalPropertiesPropertyName["Scop_2FamilyId"] = "SCOP_2_FAMILY_ID";
    FeaturesAdditionalPropertiesPropertyName["Scop_2FamilyName"] = "SCOP_2_FAMILY_NAME";
    FeaturesAdditionalPropertiesPropertyName["Scop_2SuperfamilyId"] = "SCOP_2_SUPERFAMILY_ID";
    FeaturesAdditionalPropertiesPropertyName["Scop_2SuperfamilyName"] = "SCOP_2_SUPERFAMILY_NAME";
    FeaturesAdditionalPropertiesPropertyName["ScopDomainId"] = "SCOP_DOMAIN_ID";
    FeaturesAdditionalPropertiesPropertyName["ScopName"] = "SCOP_NAME";
    FeaturesAdditionalPropertiesPropertyName["ScopSunId"] = "SCOP_SUN_ID";
    FeaturesAdditionalPropertiesPropertyName["SheetSense"] = "SHEET_SENSE";
    FeaturesAdditionalPropertiesPropertyName["StrainId"] = "STRAIN_ID";
    FeaturesAdditionalPropertiesPropertyName["Subtype"] = "SUBTYPE";
    FeaturesAdditionalPropertiesPropertyName["TargetId"] = "TARGET_ID";
    FeaturesAdditionalPropertiesPropertyName["WildType"] = "WILD_TYPE";
})(FeaturesAdditionalPropertiesPropertyName || (FeaturesAdditionalPropertiesPropertyName = {}));
export var FeaturesType;
(function (FeaturesType) {
    FeaturesType["ActiveSite"] = "ACTIVE_SITE";
    FeaturesType["AngleOutlier"] = "ANGLE_OUTLIER";
    FeaturesType["AngleOutliers"] = "ANGLE_OUTLIERS";
    FeaturesType["Artifact"] = "ARTIFACT";
    FeaturesType["Asa"] = "ASA";
    FeaturesType["AsaBound"] = "ASA_BOUND";
    FeaturesType["AsaUnbound"] = "ASA_UNBOUND";
    FeaturesType["AverageOccupancy"] = "AVERAGE_OCCUPANCY";
    FeaturesType["Bend"] = "BEND";
    FeaturesType["BindingSite"] = "BINDING_SITE";
    FeaturesType["BondOutlier"] = "BOND_OUTLIER";
    FeaturesType["BondOutliers"] = "BOND_OUTLIERS";
    FeaturesType["CalciumBindingRegion"] = "CALCIUM_BINDING_REGION";
    FeaturesType["CardModel"] = "CARD_MODEL";
    FeaturesType["Cath"] = "CATH";
    FeaturesType["Chain"] = "CHAIN";
    FeaturesType["ChiralOutliers"] = "CHIRAL_OUTLIERS";
    FeaturesType["CisPeptide"] = "CIS_PEPTIDE";
    FeaturesType["Clashes"] = "CLASHES";
    FeaturesType["CompositionallyBiasedRegion"] = "COMPOSITIONALLY_BIASED_REGION";
    FeaturesType["CovalentBond"] = "COVALENT_BOND";
    FeaturesType["CovalentModificationOfANucleotideBase"] = "COVALENT_MODIFICATION_OF_A_NUCLEOTIDE_BASE";
    FeaturesType["CovalentModificationOfANucleotidePhosphate"] = "COVALENT_MODIFICATION_OF_A_NUCLEOTIDE_PHOSPHATE";
    FeaturesType["CovalentModificationOfANucleotideSugar"] = "COVALENT_MODIFICATION_OF_A_NUCLEOTIDE_SUGAR";
    FeaturesType["CovalentResidueModification"] = "COVALENT_RESIDUE_MODIFICATION";
    FeaturesType["CrossLink"] = "CROSS_LINK";
    FeaturesType["CMannosylationSite"] = "C_MANNOSYLATION_SITE";
    FeaturesType["Disorder"] = "DISORDER";
    FeaturesType["DisorderBinding"] = "DISORDER_BINDING";
    FeaturesType["DisulfideBridge"] = "DISULFIDE_BRIDGE";
    FeaturesType["DnaBindingRegion"] = "DNA_BINDING_REGION";
    FeaturesType["Domain"] = "DOMAIN";
    FeaturesType["Ecod"] = "ECOD";
    FeaturesType["GlycosylationSite"] = "GLYCOSYLATION_SITE";
    FeaturesType["HelixP"] = "HELIX_P";
    FeaturesType["HelxLhPpP"] = "HELX_LH_PP_P";
    FeaturesType["HelxRh_3TP"] = "HELX_RH_3_T_P";
    FeaturesType["HelxRhAlP"] = "HELX_RH_AL_P";
    FeaturesType["HelxRhPiP"] = "HELX_RH_PI_P";
    FeaturesType["HydrogenBond"] = "HYDROGEN_BOND";
    FeaturesType["Hydropathy"] = "HYDROPATHY";
    FeaturesType["ImgtAntibodyDescription"] = "IMGT_ANTIBODY_DESCRIPTION";
    FeaturesType["ImgtAntibodyDomainName"] = "IMGT_ANTIBODY_DOMAIN_NAME";
    FeaturesType["ImgtAntibodyGeneAlleleName"] = "IMGT_ANTIBODY_GENE_ALLELE_NAME";
    FeaturesType["ImgtAntibodyOrganismName"] = "IMGT_ANTIBODY_ORGANISM_NAME";
    FeaturesType["ImgtAntibodyProteinName"] = "IMGT_ANTIBODY_PROTEIN_NAME";
    FeaturesType["ImgtAntibodyReceptorDescription"] = "IMGT_ANTIBODY_RECEPTOR_DESCRIPTION";
    FeaturesType["ImgtAntibodyReceptorType"] = "IMGT_ANTIBODY_RECEPTOR_TYPE";
    FeaturesType["InitiatorMethionine"] = "INITIATOR_METHIONINE";
    FeaturesType["IntramembraneRegion"] = "INTRAMEMBRANE_REGION";
    FeaturesType["IonicInteraction"] = "IONIC_INTERACTION";
    FeaturesType["LigandCovalentLinkage"] = "LIGAND_COVALENT_LINKAGE";
    FeaturesType["LigandInteraction"] = "LIGAND_INTERACTION";
    FeaturesType["LigandMetalCoordinationLinkage"] = "LIGAND_METAL_COORDINATION_LINKAGE";
    FeaturesType["LipidMoietyBindingRegion"] = "LIPID_MOIETY_BINDING_REGION";
    FeaturesType["MaQaMetricLocalTypeContactProbability"] = "MA_QA_METRIC_LOCAL_TYPE_CONTACT_PROBABILITY";
    FeaturesType["MaQaMetricLocalTypeDistance"] = "MA_QA_METRIC_LOCAL_TYPE_DISTANCE";
    FeaturesType["MaQaMetricLocalTypeEnergy"] = "MA_QA_METRIC_LOCAL_TYPE_ENERGY";
    FeaturesType["MaQaMetricLocalTypeIptm"] = "MA_QA_METRIC_LOCAL_TYPE_IPTM";
    FeaturesType["MaQaMetricLocalTypeNormalizedScore"] = "MA_QA_METRIC_LOCAL_TYPE_NORMALIZED_SCORE";
    FeaturesType["MaQaMetricLocalTypeOther"] = "MA_QA_METRIC_LOCAL_TYPE_OTHER";
    FeaturesType["MaQaMetricLocalTypePae"] = "MA_QA_METRIC_LOCAL_TYPE_PAE";
    FeaturesType["MaQaMetricLocalTypePlddt"] = "MA_QA_METRIC_LOCAL_TYPE_PLDDT";
    FeaturesType["MaQaMetricLocalTypePlddt_0_1"] = "MA_QA_METRIC_LOCAL_TYPE_PLDDT_0_1";
    FeaturesType["MaQaMetricLocalTypePlddtAllAtom"] = "MA_QA_METRIC_LOCAL_TYPE_PLDDT_ALL_ATOM";
    FeaturesType["MaQaMetricLocalTypePlddtAllAtom_0_1"] = "MA_QA_METRIC_LOCAL_TYPE_PLDDT_ALL_ATOM_0_1";
    FeaturesType["MaQaMetricLocalTypePtm"] = "MA_QA_METRIC_LOCAL_TYPE_PTM";
    FeaturesType["MaQaMetricLocalTypeZscore"] = "MA_QA_METRIC_LOCAL_TYPE_ZSCORE";
    FeaturesType["MembraneSegment"] = "MEMBRANE_SEGMENT";
    FeaturesType["MetalCoordination"] = "METAL_COORDINATION";
    FeaturesType["MetalIonBindingSite"] = "METAL_ION_BINDING_SITE";
    FeaturesType["MismatchedBasePairs"] = "MISMATCHED_BASE_PAIRS";
    FeaturesType["ModifiedMonomer"] = "MODIFIED_MONOMER";
    FeaturesType["ModifiedResidue"] = "MODIFIED_RESIDUE";
    FeaturesType["MogulAngleOutlier"] = "MOGUL_ANGLE_OUTLIER";
    FeaturesType["MogulAngleOutliers"] = "MOGUL_ANGLE_OUTLIERS";
    FeaturesType["MogulBondOutlier"] = "MOGUL_BOND_OUTLIER";
    FeaturesType["MogulBondOutliers"] = "MOGUL_BOND_OUTLIERS";
    FeaturesType["MogulRingOutliers"] = "MOGUL_RING_OUTLIERS";
    FeaturesType["MogulTorsionOutliers"] = "MOGUL_TORSION_OUTLIERS";
    FeaturesType["MutagenesisSite"] = "MUTAGENESIS_SITE";
    FeaturesType["Mutation"] = "MUTATION";
    FeaturesType["NatomsEds"] = "NATOMS_EDS";
    FeaturesType["NonConsecutiveResidues"] = "NON_CONSECUTIVE_RESIDUES";
    FeaturesType["NonStandardAminoAcid"] = "NON_STANDARD_AMINO_ACID";
    FeaturesType["NonTerminalResidue"] = "NON_TERMINAL_RESIDUE";
    FeaturesType["NucleotidePhosphateBindingRegion"] = "NUCLEOTIDE_PHOSPHATE_BINDING_REGION";
    FeaturesType["NGlycosylationSite"] = "N_GLYCOSYLATION_SITE";
    FeaturesType["Owab"] = "OWAB";
    FeaturesType["OGlycosylationSite"] = "O_GLYCOSYLATION_SITE";
    FeaturesType["Peptide"] = "PEPTIDE";
    FeaturesType["Pfam"] = "PFAM";
    FeaturesType["PlaneOutliers"] = "PLANE_OUTLIERS";
    FeaturesType["Propeptide"] = "PROPEPTIDE";
    FeaturesType["ProteinBinding"] = "PROTEIN_BINDING";
    FeaturesType["QScore"] = "Q_SCORE";
    FeaturesType["RamachandranOutlier"] = "RAMACHANDRAN_OUTLIER";
    FeaturesType["RegionOfInterest"] = "REGION_OF_INTEREST";
    FeaturesType["Repeat"] = "REPEAT";
    FeaturesType["RotamerOutlier"] = "ROTAMER_OUTLIER";
    FeaturesType["Rscc"] = "RSCC";
    FeaturesType["RsccOutlier"] = "RSCC_OUTLIER";
    FeaturesType["Rsr"] = "RSR";
    FeaturesType["Rsrz"] = "RSRZ";
    FeaturesType["RsrzOutlier"] = "RSRZ_OUTLIER";
    FeaturesType["SabdabAntibodyAntigenName"] = "SABDAB_ANTIBODY_ANTIGEN_NAME";
    FeaturesType["SabdabAntibodyHeavyChainSubclass"] = "SABDAB_ANTIBODY_HEAVY_CHAIN_SUBCLASS";
    FeaturesType["SabdabAntibodyLightChainSubclass"] = "SABDAB_ANTIBODY_LIGHT_CHAIN_SUBCLASS";
    FeaturesType["SabdabAntibodyLightChainType"] = "SABDAB_ANTIBODY_LIGHT_CHAIN_TYPE";
    FeaturesType["SabdabAntibodyName"] = "SABDAB_ANTIBODY_NAME";
    FeaturesType["SabdabAntibodyTarget"] = "SABDAB_ANTIBODY_TARGET";
    FeaturesType["Scop"] = "SCOP";
    FeaturesType["Scop_2BSuperfamily"] = "SCOP_2_B_SUPERFAMILY";
    FeaturesType["Scop_2Family"] = "SCOP_2_FAMILY";
    FeaturesType["Scop_2Superfamily"] = "SCOP_2_SUPERFAMILY";
    FeaturesType["SequenceConflict"] = "SEQUENCE_CONFLICT";
    FeaturesType["SequenceVariant"] = "SEQUENCE_VARIANT";
    FeaturesType["Sheet"] = "SHEET";
    FeaturesType["ShortSequenceMotif"] = "SHORT_SEQUENCE_MOTIF";
    FeaturesType["SignalPeptide"] = "SIGNAL_PEPTIDE";
    FeaturesType["Site"] = "SITE";
    FeaturesType["SpliceVariant"] = "SPLICE_VARIANT";
    FeaturesType["StereoOutlier"] = "STEREO_OUTLIER";
    FeaturesType["Strn"] = "STRN";
    FeaturesType["SymmClashes"] = "SYMM_CLASHES";
    FeaturesType["SGlycosylationSite"] = "S_GLYCOSYLATION_SITE";
    FeaturesType["TopologicalDomain"] = "TOPOLOGICAL_DOMAIN";
    FeaturesType["TransitPeptide"] = "TRANSIT_PEPTIDE";
    FeaturesType["TransmembraneRegion"] = "TRANSMEMBRANE_REGION";
    FeaturesType["TurnTy_1P"] = "TURN_TY_1_P";
    FeaturesType["UnassignedSecStruct"] = "UNASSIGNED_SEC_STRUCT";
    FeaturesType["UnobservedAtomXyz"] = "UNOBSERVED_ATOM_XYZ";
    FeaturesType["UnobservedResidueXyz"] = "UNOBSERVED_RESIDUE_XYZ";
    FeaturesType["UnsureResidue"] = "UNSURE_RESIDUE";
    FeaturesType["ZeroOccupancyAtomXyz"] = "ZERO_OCCUPANCY_ATOM_XYZ";
    FeaturesType["ZeroOccupancyResidueXyz"] = "ZERO_OCCUPANCY_RESIDUE_XYZ";
    FeaturesType["ZincFingerRegion"] = "ZINC_FINGER_REGION";
})(FeaturesType || (FeaturesType = {}));
export var FieldName;
(function (FieldName) {
    FieldName["TargetId"] = "TARGET_ID";
    FieldName["Type"] = "TYPE";
})(FieldName || (FieldName = {}));
export var GroupReference;
(function (GroupReference) {
    GroupReference["MatchingUniprotAccession"] = "MATCHING_UNIPROT_ACCESSION";
    GroupReference["SequenceIdentity"] = "SEQUENCE_IDENTITY";
})(GroupReference || (GroupReference = {}));
export var OperationType;
(function (OperationType) {
    OperationType["Contains"] = "CONTAINS";
    OperationType["Equals"] = "EQUALS";
})(OperationType || (OperationType = {}));
export var SequenceReference;
(function (SequenceReference) {
    SequenceReference["NcbiGenome"] = "NCBI_GENOME";
    SequenceReference["NcbiProtein"] = "NCBI_PROTEIN";
    SequenceReference["PdbEntity"] = "PDB_ENTITY";
    SequenceReference["PdbInstance"] = "PDB_INSTANCE";
    SequenceReference["Uniprot"] = "UNIPROT";
})(SequenceReference || (SequenceReference = {}));
//# sourceMappingURL=GqlTypes.js.map